module.exports = __webpack_public_path__ + "h5/img/logo2.91d67969.png";